const INITIAL_STATE = {
  produto: {
    data: [],
    current_page: 1,
    last_page: 1,
    per_page: 20,
    total: 0
  },
  passeioEnd: {},
  capacidadeFrequencia: {}
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'PRODUTOS_FETCHED':
      // Se payload é um objeto paginado (tem propriedade 'data')
      if (action.payload && typeof action.payload === 'object' && 'data' in action.payload) {
        return {
          ...state,
          produto: {
            data: Array.isArray(action.payload.data) ? action.payload.data : [],
            current_page: action.payload.current_page || 1,
            last_page: action.payload.last_page || 1,
            first_page: 1,
            per_page: action.payload.per_page || 20,
            total: action.payload.total || 0
          },
          passeioEnd: action.payload
        }
      }
      // Se payload é um array direto
      return {
        ...state,
        produto: {
          ...state.produto,
          data: Array.isArray(action.payload) ? action.payload : []
        },
        passeioEnd: action.payload
      }

    case 'FREQUENCIA_CAPACIDADE_FETCHED':
      return {
        ...state, capacidadeFrequencia: action.payload
      }

    case 'PASSEIOEND_SET':
      const endereco = { ...state.passeioEnd }
      endereco[action.payload.propriedade] = action.payload.value
      return { ...state, passeioEnd: endereco }

    default:
      return state
  }
}